import { orderBy } from 'lodash';
import { useQuery } from 'react-query';

import { getStoredXerFileVersions as queryFn } from 'api/endPoints/getStoredXerFileVersions';
import { IVersion } from 'api/queries/getProjectVersionsList.query';

export const useQueryGetVersionsList = (params) => {
    return useQuery<IVersion[], QueryError>(['useQueryGetVersionsList', params], () => queryFn(params), {
        enabled: Boolean(params.projectId && params.contractId),
        select: (response) => {
            return orderBy(response, ['versionDate'], ['desc']).filter((i) => i.status === 'OK');
        },
    });
};
